import React from "react";
import Section from "../../../HOC/Section";

const Education = () => {
  return (
    <Section id="Education">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span> </span>Eğitimlerim
          </h3>
          <ul class="list-group">
            <li class="list-group-item">•	Bilişsel Davranışçı Terapi</li>
            <li class="list-group-item">•	Çocuk ve Ergenlerde Bilişsel Davranışçı Terapi</li>
            <li class="list-group-item">•	Çocuklarda Görülen Uyum Davranış Bozukluklarına  Müdahale</li>
            <li class="list-group-item">•	Kısa Süreli Çözüm Odaklı Terapi</li>
            <li class="list-group-item">•	Şema Terapi</li>
            <li class="list-group-item">•	Aile Danışmanlığı </li>
            <li class="list-group-item">•	Oyun Terapisi</li>
            <li class="list-group-item">•	Moxo Dikkat Testi</li>
            <li class="list-group-item">•	Attentioner Dikkatimi Topluyorum </li>
            <li class="list-group-item">•	Kişilerarası  İlişkiler Psikoterapi Eğitimi</li>
            <li class="list-group-item">•	Cinsel Terapi  Eğitimi </li>
          </ul>
        </div>
      </div>
    </Section>
  );
};

export default Education;
